import Vue from 'vue'
import Router from 'vue-router'
import Layout from './views/layout.vue'
import NoResult from './components/404.vue'
// import Home from './views/home.vue'

Vue.use(Router)

let router = new Router({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    
    
    {
      path: '/',
      name: 'pc',
      component: Layout,
      redirect: { name: 'ppst' },
      children: [
        // { path: 'home', name: 'home', component: Home },
        { path: '/ppst', name: 'ppst', beforeEnter: (to, from, next) => {
            let MultLang = navigator.language || navigator.browserLanguage;
            if(/^pt/.test(MultLang)) {
              MultLang = 'pt'
            }else {
              MultLang = 'en'
            }
            next({ path: '/ppst/' + MultLang })
          }, component: () => import('./views/ppst.vue') },
        { path: '/ppst/:lang', name: 'ppst-lang', component: () => import('./views/ppst.vue') },
        // { path: 'ppwc', name: 'events', component: () => import('./views/events.vue') },
        // { path: 'activate', name: 'upcoming-activate', redirect: { name: 'upcoming-activate-step1' }, component: () => import('./views/eventsActivate.vue'), children: [
        //   { path: 'step1', name: 'upcoming-activate-step1', component: () => import('./views/activate/signForm1.vue')},
        //   { path: 'step2', name: 'upcoming-activate-step2', component: () => import('./views/activate/signForm2.vue')},
        //   { path: 'step3', name: 'upcoming-activate-step3', component: () => import('./views/activate/signTable.vue')},
        //   { path: 'step4', name: 'upcoming-activate-step4', component: () => import('./views/activate/signStep4.vue')},
        //   { path: 'step5', name: 'upcoming-activate-step5', component: () => import('./views/activate/signedTable.vue')},
        // ]},
        // { path: 'activate', name: 'upcoming-activate-dec', component: () => import('./views/eventsActivate.vue'), children: [
        //     { path: ':dec', name: 'upcoming-activate-dec-step1', component: () => import('./views/activate/signForm1.vue')}
        //   ]
        // },
        // { path: 'festival', name: 'festival', component: () => import('./views/festival.vue') },
        // { path: 'festival/upcoming/:id', name: 'festival-upcoming', component: () => import('./views/festivalUpcoming.vue') },
        // { path: 'festival/past/:id', name: 'festival-past', component: () => import('./views/festivalPast.vue') },
        // { path: 'blog', name: 'blog', component: () => import('./views/blog.vue') },
        // { path: 'blog/:item', name: 'blog-item', component: () => import('./views/blogItem.vue') },
        // { path: 'about', name: 'about', component: () => import('./views/about.vue') },
        // { path: 'brand', name: 'brand', component: () => import('./views/brand.vue') },
        // { path: 'legal-affairs/Privacy', name: 'legalPrivacy', component: () => import('./views/legalPrivacy.vue') },
        // { path: 'legal-affairs/Terms', name: 'legalTerms', component: () => import('./views/legalTerms.vue') },
        // { path: 'legal-affairs/Unsolicited', name: 'legalUnsolicited', component: () => import('./views/legalUnsolicited.vue') },
        // { path: 'legal-affairs/Community', name: 'legalCommunity', component: () => import('./views/legalCommunity.vue') },
        // { path: 'faq', name: 'faq', component: () => import('./views/faq.vue') }
      ]
    },
    { path: '/privacy-policy', name: 'privacy-policy', component: () => import('./views/privacyPolicy.vue') },
    { path: '/user-agreement', name: 'user-agreement', component: () => import('./views/userAgreement.vue') },
    { path: '/privacy-policy-ppwc', name: 'privacy-policy-ppwc', component: () => import('./views/privacyPolicyPPWC.vue') },
    { path: '/user-agreement-ppwc', name: 'user-agreement-ppwc', component: () => import('./views/userAgreementPPWC.vue') },
    { path: '/user-agreement-ppwc-braze', name: 'user-agreement-ppwc-braze', component: () => import('./views/userAgreementPPWCBraze.vue') },
    {
      path: '*',
      name: 'NoResult',
      component: NoResult
    }
  ]
})

// router.beforeEach((to, from, next) => {
//   if (isMobile()) {
//     if (window.location.href.indexOf('/index.html') !== -1) {
//       window.location.href = window.location.href.replace('/index.html', '/official_mobile.html')
//     } else {
//       window.location.href = window.location.href.replace('#/', 'official_mobile.html#/')
//       // window.location.href = '/official_mobile.html'
//     }
//   } else {
//     next()
//   }
// })

// router.afterEach((to, from) => {
//   let name = location.hostname + '#' + to.path
//   ga('set', 'page', name);
//   ga('send', 'pageview');
// })

export default router
